import { Container, SxProps } from "@mui/material";
import Page from "src/components/Page";

import BackgroundImage from "./components/BackgroundImage";
import DemoTitle from "./components/DemoTitle";
import LogoHeader from "./components/LogoHeader";
import DemoBanner from "./DemoBanner";
import DemoServiceGrid from "./DemoServiceGrid";

// ----------------------------------------------------------------------

const containerSx: SxProps = { display: "flex", flex: 1, flexDirection: "column" };

export const DemoLink = () => {
	return (
		<Page title='Demo'>
			<Container maxWidth={false} sx={containerSx} disableGutters>
				<BackgroundImage />
				<LogoHeader />
				<DemoTitle />
				<DemoServiceGrid />
				<DemoBanner />
			</Container>
		</Page>
	);
};

export default DemoLink;
